import { ColorFilterOptions } from '../../../constants/colorFilterOptions';
import HorseFilterComparator from './horseFilterComparator';
export const horsesFilterConfig = [
    {
        label: 'Name',
        stateKey: 'name',
        filterKeys: ['name'],
        hidden: true,
        comparator: HorseFilterComparator.name
    },
    {
        label: 'Gender',
        stateKey: 'gender',
        filterKeys: ['gender'],
        comparator: HorseFilterComparator.gender,
        textFilterOptions: [
            { name: 'Female', value: 'Female' },
            { name: 'Male', value: 'Male' }
        ]
    },
    {
        label: 'Condition',
        stateKey: 'condition',
        filterKeys: ['condition'],
        comparator: HorseFilterComparator.condition,
        textFilterOptions: [
            { name: 'Activated', value: 'Activated' },
            { name: 'Non-Activated', value: 'Non-Activated' },
            { name: 'Foal', value: 'Foal' }
        ]
    },
    {
        label: 'Color',
        stateKey: 'color',
        filterKeys: ['color'],
        comparator: HorseFilterComparator.color,
        colorFilterOptions: ColorFilterOptions
    },
    {
        label: 'Age',
        stateKey: 'age',
        filterKeys: ['ageMin', 'ageMax'],
        comparator: HorseFilterComparator.age,
        range: { min: 0, max: 10 }
    },
    {
        label: 'Total',
        stateKey: 'totalStats',
        filterKeys: ['totalMin', 'totalMax'],
        comparator: HorseFilterComparator.totalStats,
        range: { min: 0, max: 200 }
    },
    {
        label: 'Speed',
        stateKey: 'speed',
        filterKeys: ['speedMin', 'speedMax'],
        comparator: HorseFilterComparator.speed,
        range: { min: 0, max: 100 }
    },
    {
        label: 'Stamina',
        stateKey: 'stamina',
        filterKeys: ['staminaMin', 'staminaMax'],
        comparator: HorseFilterComparator.stamina,
        range: { min: 0, max: 100 }
    },
    {
        label: 'Acceleration',
        stateKey: 'acceleration',
        filterKeys: ['accelerationMin', 'accelerationMax'],
        comparator: HorseFilterComparator.acceleration,
        range: { min: 0, max: 100 }
    },
    {
        label: 'Endurance',
        stateKey: 'endurance',
        filterKeys: ['enduranceMin', 'enduranceMax'],
        comparator: HorseFilterComparator.endurance,
        range: { min: 0, max: 100 }
    },
    {
        label: 'Agility',
        stateKey: 'agility',
        filterKeys: ['agilityMin', 'agilityMax'],
        comparator: HorseFilterComparator.agility,
        range: { min: 0, max: 100 }
    }
];
